import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantBankService,
  //  eslint-disable-next-line camelcase
  type PagedResultDto_ParticipantBankListDto,
} from '../../services/wealthlane-finance-integration-services';

const useGetParticipantBankList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  //  eslint-disable-next-line camelcase
  PagedResultDto_ParticipantBankListDto | undefined,
  unknown
> => {
  const participantBankList = useQuery(
    ['getParticipantBankList'],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankParticipantBankList()
      );
    },
    {
      cacheTime: 1000 * 60 * 5,
    }
  );

  return participantBankList;
};

export default useGetParticipantBankList;
